<!--
 * @Author: cn1994
 * @Date: 2022-08-29 17:40:06
 * @LastEditors: cn1994
 * @LastEditTime: 2023-04-11 16:21:35
 * @Description: 分页组件
-->
<template>
  <div class="ls-pagination-component" v-if="total >= showLimit">
    <span v-if="showTotalValue">{{ totalValue }}</span>
    <el-pagination
      :pager-count="pagerCount"
      background
      :layout="layout"
      :page-sizes="pageSizes"
      :page-size="defaultSize"
      :current-page.sync="currentPage"
      :total="~~total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: [String, Number],
      default: 0,
    },
    defaultSize: {
      type: [String, Number],
      default: 10,
    },
    pagerCount: {
      type: [Number],
      default: 7,
    },
    current: {
      type: [String, Number],
      default: 1,
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
    layout: {
      type: String,
      default: "prev, pager, next, sizes",
    },
    showTotalValue: {
      type: Boolean,
      default: true
    },
    showLimit: {
      type: [Number,String],
      default: 10
    }
  },
  data() {
    return {
      pageNum: this.defaultSize,
      page: 1,
    };
  },
  computed: {
    totalValue() {
      if (this.total == 0) {
        return `共0条`;
      }
      return `共${this.total}条`;
    },
    currentPage: {
      get() {
        return this.current;
      },
      set(v) {
        this.$emit("update:current", v);
      },
    },
  },
  methods: {
    // 分页条数改变
    handleSizeChange(data) {
      this.pageNum = data;
      this.$emit("handleSizeChange", data);
    },
    // 页数改变
    handleCurrentChange(data) {
      this.page = data;
      this.$emit("handleCurrentChange", data);
    },
  },
};
</script>

<style lang="less" scoped>
.ls-pagination-component {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #555555;

  /deep/ .el-pagination.is-background {
    padding: 0;
    .el-pager li:not(.disabled).active {
      color: #007aff;
      border: 1px solid #007aff;
      border-radius: 4px;
    }
    .el-pager li {
      background-color: #fff;
      border: 1px solid #d9d9d9;
      color: rgba(0, 0, 0, 0.65);
      min-width: 32px;
      height: 32px;
      line-height: 32px;
      font-weight: normal;
    }
    .btn-prev,
    .btn-next {
      width: 32px;
      height: 32px;
      line-height: 30px;
      background-color: #fff;
      border: 1px solid #d9d9d9;
      color: rgba(0, 0, 0, 0.65);
    }
    .el-input {
      margin: 0 0 0 11px;
      width: 90px;
    }
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
    .el-pagination__sizes {
      margin: 0;
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>